module.exports = __webpack_public_path__ + "media/fanfare.538b7ed7.mp3";